// Anti-gaming guard on the platform base charge: a tenant is billed on
// ONE count (drivers or vehicles, tenants.platform_billing_basis) but
// can't shrink that bill by loading up the OTHER count disproportionately
// -- e.g. staying on 1 driver while running 50 vehicles. The billed count
// is never less than half the other count, rounded up. Never blocks
// activating anything; it only ever changes what gets billed.
//
//   billed on drivers:  max(activeDrivers, ceil(activeVehicles / 2))
//   billed on vehicles: max(activeVehicles, ceil(activeDrivers / 2))
//
// Only active drivers/vehicles count -- archived/inactive records never
// affect the base charge.
export type PlatformBillingBasis = 'drivers' | 'vehicles';

export interface BillableUnitsResult {
  billableUnits: number;
  rawCount: number;
  guardApplied: boolean;
}

export function calculateBillableUnits(
  basis: PlatformBillingBasis,
  activeDrivers: number,
  activeVehicles: number
): BillableUnitsResult {
  const rawCount = basis === 'drivers' ? activeDrivers : activeVehicles;
  const otherCount = basis === 'drivers' ? activeVehicles : activeDrivers;
  const guardFloor = Math.ceil(otherCount / 2);
  const billableUnits = Math.max(rawCount, guardFloor);
  return { billableUnits, rawCount, guardApplied: billableUnits > rawCount };
}
